import moment from "moment";

export const columns = [
  {
    accessorKey: "vehicleNumber",
    header: "Vehicle",
    type: "string",
    size: 140,
  },
  { accessorKey: "driverName", header: "Driver", size: 140 },
  {
    accessorKey: "vehicleType",
    header: "Type",
    type: "string",
    size: 140,
  },
  { accessorKey: "vehicleStatus", header: "Status", size: 140 },
  {
    accessorKey: "consignmentType",
    header: "Consignment ",
    description: "This column has a value getter and is not sortable.",
    sortable: true,
    size: 180,
  },
  {
    accessorKey: "gdNumber",
    header: "GD#",
    size: 140,
    accessorFn: (row: any) => ` ${row.gdNumber || " "}`,
  },
  { accessorKey: "terminalLocation", header: "Location", size: 160 },
  { accessorKey: "cargoTypeName", header: "Cargo", size: 140 },
  {
    accessorKey: "yardSlotInfo",
    header: "Yard",
    size: 140,
    accessorFn: (row: any) => ` ${row.yardSlotInfo || " "}`,
  },
  {
    accessorKey: "gateEntryDate",
    header: "Entry",
    size: 145,
    accessorFn: function customCell(row: any) {
      return `${
        row.gateEntryDate ? moment(row.gateEntryDate).format("DD-MM-YYYY hh:mm:ss A") : ""
      }`;
    },
  },
  {
    accessorKey: "isAnomlyDetected",
    header: "Anomaly",
    size: 150,
    type: "boolean",
  },
  {
    accessorKey: "vehicleInProgress",
    header: "In Progress ",
    size: 170,
    type: "boolean",
  },
  {
    accessorKey: "deletedBy",
    header: "Deleted By",
    size: 170,
    accessorFn: (row: any) => ` ${row.deletedBy || " "}`,
  },
  {
    accessorKey: "deletedAt",
    header: "Deleted At",
    size: 170,
    accessorFn: function customCell(row: any) {
      return `${row.deletedAt ? moment(row.deletedAt).format("DD-MM-YYYY hh:mm:ss A") : ""}`;
    },
  },
];
